import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useI18n } from '../../lib/i18n';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useI18n();
  return <div className="flex items-center gap-1 rounded-full border border-[rgba(217,217,217,0.2)] bg-[rgba(217,217,217,0.06)] p-1" data-id="element-154" data-mp="zirrrqfxlp65">
      <GlobeIcon className="ml-1.5 mr-0.5 h-4 w-4 text-silver" aria-hidden="true" data-id="element-155" data-mp="18glgaf7gfeir" />
      <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${lang === 'en' ? 'bg-neon text-white' : 'text-silver hover:text-white'}`} data-id="element-156" data-mp="kqr9ofdqam6y">
        EN
      </button>
      <button type="button" onClick={() => setLang('am')} aria-pressed={lang === 'am'} className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${lang === 'am' ? 'bg-neon text-white' : 'text-silver hover:text-white'}`} data-id="element-157" data-mp="ppklm3dda550">
        አማ
      </button>
    </div>;
}